@if (chunk()) {
  <div (click)="setAsCurrent($event)" class="chunk relative transition-all duration-300 ease-in-out" [class.chunk--selected]="isSelected()" [id]="chunk()?._id" #editorWrapper>
    <!-- The controller is rendered first so on mobile (position:static) it appears above the content -->
    <app-chunk-controller
      [style.display]="isCurrent() || isGeneratingTask() || isMultiSelectMode() ? 'block' : 'none'"
      [editorWrapper]="editorWrapper"
      [isTextual]="isTextual()"
      [isCode]="isCode()"
      [isMedia]="isMedia()"
      [contentID]="contentID"
      [chunk]="chunk()"
      [courseID]="courseID"
      [blogID]="blogID"
      [nodelete]="nodelete"
      [chunkAboveId]="chunkAboveId"
      [chunkBelowId]="chunkBelowId"
      [readOnly]="readOnly"
      (play)="emitPlayAction($event)"
      (pause)="emitPauseAction()"
      (playVideoAt)="cdService.passVideoAction({ action: 'play', chunkID: chunk()?._id, timestamp: $event })"
      (editionCreated)="chunkService.passChunkEditEvent({ event: 'handleEditionManipulationSuccessEvent', chunkID: chunk()?._id })"
      (click)="$event.stopPropagation()"
    />

    @if (isLoading() || chunk()?.isPlaceHolder) {
      <ui-skeleton [type]="chunk().type" />
    } @else {
      @if (isCurrent()) {
        <div class="progress" [style]="chunk().progress"></div>
      }

      <!-- The main display area for the chunk's content -->
      @if (!readOnly && appCreateMode() && highlightedChunk() === chunk()?._id && isTextual()) {
        <app-create-chunk
          (click)="$event.stopPropagation()"
          [mode]="'modify-chunk'"
          [chunkAboveId]="chunkAboveId"
          [chunkBelowId]="chunkBelowId"
          [chunkType]="chunk().type"
          [chunkToEdit]="chunk()"
          [contentID]="contentID"
          [showOptions]="false"
          (doneEditing)="onDoneEditing()"
          [clickEvent]="clickEvent()"
        />
      } @else {
        <app-chunk-displayer [chunk]="chunk()" [highlightedChunk]="highlightedChunk()" />
      }
    }
  </div>
}
